// extracted by mini-css-extract-plugin
export default {"avatar":"RequestBody_avatar__neizT"};